export interface DentalTreatment {
  id: string;
  name: string;
  category: "Cosmetic Dentistry" | "Orthodontics" | "Implantology" | "Periodontics" | "Endodontics";
  tagline: string;
  priceINR: number;
  priceUSD: number;
  duration: string;
  anesthesia: string;
  warranty: string;
  badge?: string;
  highlights: string[];
}

export const DENTAL_TREATMENTS: DentalTreatment[] = [
  {
    id: "veneer-makeover",
    name: "Full-Mouth Digital Smile Makeover (E.max Veneers)",
    category: "Cosmetic Dentistry",
    tagline: "Hand-layered ceramic porcelain veneers engineered for flawless luminescence and facial harmony.",
    priceINR: 240000,
    priceUSD: 2950,
    duration: "2 Appointments (48-hr turnaround)",
    anesthesia: "Micro-local / Wand Painless System",
    warranty: "10-Year Clinical Porcelain Guarantee",
    badge: "MOST POPULAR",
    highlights: [
      "Digital Smile Design (DSD) 3D facial aesthetic mapping",
      "Minimal prep ultra-thin 0.3mm Ivoclar Vivadent E.max porcelain",
      "In-house master ceramist shade and texture matching",
      "Complimentary diagnostic trial smile wax-up"
    ],
  },
  {
    id: "clear-aligners",
    name: "Invisible Clear Aligners (3D Biomechanical Staging)",
    category: "Orthodontics",
    tagline: "Custom laser-trimmed transparent aligners correcting crowding, gaps, and overbites discreetly.",
    priceINR: 165000,
    priceUSD: 1980,
    duration: "6 - 14 Months Average Duration",
    anesthesia: "Non-invasive (Zero Anesthesia)",
    warranty: "Lifetime Retention & Refinement Support",
    badge: "DIGITAL ORTHO",
    highlights: [
      "iTero Lumina 6,000 frames/sec 3D intraoral diagnostic scan",
      "Full digital ClinCheck simulation before starting",
      "Medical-grade multi-layer SmartTrack polymer material",
      "Remote monitoring app with weekly doctor check-ins"
    ],
  },
  {
    id: "all-on-4-implants",
    name: "Nobel Biocare All-on-4 Immediate Dental Implants",
    category: "Implantology",
    tagline: "Permanent full-arch fixed teeth reconstruction anchored by Swiss-engineered titanium implants.",
    priceINR: 380000,
    priceUSD: 4650,
    duration: "Same-Day Teeth Delivery",
    anesthesia: "Twilight IV Sedation / Painless Wand",
    warranty: "Lifetime International Nobel Warranty",
    badge: "SURGICAL EXCELLENCE",
    highlights: [
      "CBCT 3D bone density analysis & computer-guided surgery",
      "Immediate loading fixed PMMA bridge delivered within 24 hours",
      "Grade 5 medical titanium Swiss Nobel Biocare implants",
      "Permanent monolithic high-translucency Zirconia final bridge"
    ],
  },
  {
    id: "laser-perio",
    name: "Laser Periodontal Regeneration & Deep Micro-Scaling",
    category: "Periodontics",
    tagline: "Minimally invasive diode laser therapy restoring diseased gum pockets and bone stability.",
    priceINR: 45000,
    priceUSD: 550,
    duration: "Single 75-minute Session",
    anesthesia: "Topical Gel & Micro-infiltration",
    warranty: "1-Year Clinical Maintenance Protocol",
    highlights: [
      "Waterlase iPlus Er,Cr:YSGG non-scalpel laser sterilization",
      "Subgingival ultrasonic plaque and calculus removal",
      "Growth factor platelet-rich fibrin (PRF) bio-stimulation",
      "Complete elimination of gum bleeding and inflammation"
    ],
  },
  {
    id: "zoom-whitening",
    name: "Philips Zoom Whitespeed Clinical Laser Whitening",
    category: "Cosmetic Dentistry",
    tagline: "In-office light-accelerated technology brightening smiles up to 8 shades in a single chair session.",
    priceINR: 28000,
    priceUSD: 350,
    duration: "45 Minutes Chair Time",
    anesthesia: "Zero Anesthesia Required",
    warranty: "Includes Custom Home Booster Trays",
    highlights: [
      "Clinically proven up to 8 shades lighter without enamel damage",
      "Relief ACP desensitizing protection applied post-treatment",
      "High-intensity cold blue LED activation chamber",
      "Custom take-home bleaching trays and maintenance gel syringes"
    ],
  },
];

export interface DentalDoctor {
  id: string;
  name: string;
  title: string;
  specialty: string;
  degrees: string;
  experience: string;
  fellowships: string;
}

export const DENTAL_DOCTORS: DentalDoctor[] = [
  {
    id: "dr-aanya",
    name: "Dr. Aanya Singhania",
    title: "Clinical Director & Chief Prosthodontist",
    specialty: "Digital Smile Design, E.max Porcelain Veneers & Full Mouth Rehab",
    degrees: "BDS, MDS (Prosthodontics - Gold Medalist)",
    experience: "14+ Years Clinical Practice",
    fellowships: "Fellow of the International Congress of Oral Implantologists (FICOI, USA)"
  },
  {
    id: "dr-rohan",
    name: "Dr. Rohan Mehra",
    title: "Chief Oral & Maxillofacial Implant Surgeon",
    specialty: "Nobel Biocare All-on-4, Immediate Loading & 3D Bone Grafting",
    degrees: "BDS, MDS (Oral & Maxillofacial Surgery)",
    experience: "16+ Years Surgical Practice",
    fellowships: "Diplomate, European Association for Osseointegration (EAO, Zurich)"
  },
  {
    id: "dr-preeti",
    name: "Dr. Preeti Sharma",
    title: "Senior Orthodontist & Aligner Specialist",
    specialty: "Clear Aligner Biomechanics, Teen Ortho & Lingual Braces",
    degrees: "BDS, MDS (Orthodontics & Dentofacial Orthopedics)",
    experience: "11+ Years Ortho Practice",
    fellowships: "Invisalign Diamond Apex Certified Provider"
  },
  {
    id: "dr-vikram",
    name: "Dr. Vikramaditya Rao",
    title: "Consultant Microscopic Endodontist",
    specialty: "Painless Single-Sitting Micro-Root Canals under Carl Zeiss Optics",
    degrees: "BDS, MDS (Conservative Dentistry & Endodontics)",
    experience: "12+ Years Microscope Endodontics",
    fellowships: "Certified Member, American Association of Endodontists (AAE)"
  },
];

export const CONSULTATION_TYPES = [
  "Comprehensive Smile Makeover Consultation (with 3D Scan)",
  "Dental Implant & Missing Teeth Evaluation (with CBCT Scan)",
  "Clear Aligners & Orthodontic Assessment",
  "Urgent Dental Pain & Root Canal Emergency",
  "Routine Dental Spa & Ultrasonic Hygiene Cleaning",
];

export const CLINIC_TIME_SLOTS = [
  "Morning Slot (10:00 AM - 12:30 PM)",
  "Afternoon Slot (01:30 PM - 04:00 PM)",
  "Evening Slot (05:00 PM - 07:30 PM)",
];

export const DENTAL_TECHNOLOGIES = [
  {
    name: "iTero Lumina 3D Intraoral Scanner",
    description: "Captures photorealistic 3D digital dental impressions at 6,000 frames per second without traditional unpleasant trays.",
    metric: "100% Digital",
  },
  {
    name: "Carestream CS 9600 CBCT Scanner",
    description: "Ultra low-dose 3D cone-beam volumetric tomography revealing bone depth and nerve pathways down to 75 microns.",
    metric: "75μm Resolution",
  },
  {
    name: "STA Wand Computerized Anesthesia",
    description: "Microprocessor-controlled single tooth anesthesia providing totally painless injections without face numbness.",
    metric: "Painless Delivery",
  },
  {
    name: "Carl Zeiss ProErgo Dental Microscopes",
    description: "Magnifies the tooth anatomy up to 25x with xenon illumination for unmatched surgical precision and margin fit.",
    metric: "25x Optical Zoom",
  }
];
